import { useState } from "react";
import { Col, InputGroup, Label, Row } from "reactstrap";
import DatePicker, { DateObject } from "react-multi-date-picker";
import { MultiplesDatesHeading } from "../../../../../utils/Constant";

const MultiplesDates = () => {
  const [startDate, setStartDate] = useState<DateObject[]>([]);
  const handleChange = (date: DateObject[]) => setStartDate(date);

  return (
    <Row>
      <Col xxl="3">
        <Label className="box-col-12 text-start" check>
          {MultiplesDatesHeading}
        </Label>
      </Col>
      <Col xxl="9" className="box-col-12">
        <InputGroup className="flatpicker-calender">
          <DatePicker inputClass="form-control" multiple dateSeparator="::" value={startDate} onChange={handleChange} />
        </InputGroup>
      </Col>
    </Row>
  );
};

export default MultiplesDates;
